import { apiClient } from '@/lib/api'
import type { HINLookupResult, Inspection, InspectionCreateBody } from '@/types/inspection'

// Normalize a HIN the same way the backend does: uppercase, strip the spaces
// and dashes people add when transcribing a plate.
export const normalizeHIN = (hin: string) => hin.toUpperCase().replace(/[\s.-]/g, '')

export const lookupHIN = async (hin: string): Promise<HINLookupResult> =>
  apiClient<HINLookupResult>('/inspection/lookup', { params: { hin } })

export interface InspectionFilters {
  q?: string
  boatId?: string
  workOrderId?: string
  /** Only inspections not linked to any work order (the adoption pool). */
  unattached?: boolean
}

export const fetchInspections = async (filters: InspectionFilters = {}): Promise<Inspection[]> => {
  const params: Record<string, string> = {}
  if (filters.q) params.q = filters.q
  if (filters.boatId) params.boat_id = filters.boatId
  if (filters.workOrderId) params.work_order_id = filters.workOrderId
  if (filters.unattached) params.unattached = 'true'
  return apiClient<Inspection[]>('/inspection', {
    params: Object.keys(params).length > 0 ? params : undefined,
  })
}

export const fetchInspectionById = async (id: string): Promise<Inspection> =>
  apiClient<Inspection>(`/inspection/${id}`)

export const createInspection = async (body: InspectionCreateBody): Promise<Inspection> =>
  apiClient<Inspection>('/inspection', { method: 'POST', body })
